import React from 'react'

const GraduationCapIcon = props => (
  <svg viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g opacity="0.3">
      <path
        d="M1.6098 2.45079L1.57361 2.43101V2.42951L1.6098 2.45079Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M8.67793 4.02037C8.67793 4.01702 8.67626 4.01366 8.67626 4.01199C8.6662 3.80705 8.68296 3.60562 8.62917 3.40403C8.60236 3.29997 8.5737 3.22942 8.48304 3.1706C8.3773 3.10172 8.27307 3.0295 8.15895 2.97403C7.87676 2.83294 7.58116 2.73725 7.2688 2.67173C6.59364 2.53231 5.91346 2.49879 5.22992 2.5256C4.94438 2.53733 4.659 2.55744 4.3768 2.59783C3.89821 2.66838 3.43135 2.78585 3.0047 3.02615C2.84517 3.11513 2.73089 3.17395 2.68564 3.35862C2.5799 3.79532 2.5866 4.47885 2.57303 4.92393C2.57135 5.00788 2.60319 5.06838 2.66704 5.11027C2.72921 5.15233 2.79473 5.19088 2.86528 5.21936C3.2817 5.38727 3.72678 5.43604 4.16683 5.49988C4.39356 5.5334 4.62531 5.54362 4.85372 5.55032C5.8714 5.58049 6.88924 5.57881 7.89184 5.36733C8.12527 5.31857 8.34865 5.21618 8.57203 5.12887C8.6476 5.09871 8.69804 5.02816 8.69637 4.93734C8.69134 4.72066 8.68966 4.23704 8.67793 4.02037ZM8.26134 5.04978C8.15225 5.09854 8.03797 5.14546 7.92217 5.16741C7.71388 5.2078 7.50223 5.24299 7.29075 5.25807C6.88774 5.28488 6.48288 5.30684 6.07986 5.32695C5.92871 5.33532 5.77923 5.33868 5.62975 5.337C5.38962 5.337 5.15284 5.32695 4.91103 5.31522C4.6104 5.30013 4.31145 5.28338 4.01249 5.25807C3.70014 5.22958 3.38275 5.20261 3.08547 5.08514C3.07542 5.08178 3.06369 5.08011 3.05531 5.07508C2.97303 5.03805 2.86394 4.95912 2.968 4.88187C3.03688 4.83143 3.13256 4.81635 3.21316 4.79456C3.35761 4.7525 3.50709 4.71731 3.65657 4.69385C4.199 4.60822 4.74479 4.58476 5.29394 4.58811C5.80453 4.59146 6.31497 4.58141 6.82557 4.60822C7.20009 4.62833 7.57295 4.69553 7.94412 4.75099C8.03813 4.7644 8.13549 4.77948 8.22129 4.81987C8.31346 4.86343 8.40076 4.98761 8.26134 5.04978Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M1.75694 4.79154C1.84424 5.10892 2.07767 6.04432 2.07767 6.82371C2.07767 6.82371 1.98031 6.97989 1.60914 7C1.23963 6.97989 1.14227 6.82371 1.14227 6.82371C1.14227 6.04449 1.3757 5.10892 1.46133 4.79154C1.38576 4.74277 1.33699 4.65882 1.33699 4.56313C1.33699 4.43544 1.4243 4.3297 1.54194 4.29954V3.78224L1.67801 3.86284V4.29954C1.79548 4.3297 1.88295 4.43561 1.88295 4.56313C1.88278 4.65882 1.83251 4.74277 1.75694 4.79154Z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M10.8742 2.9133C10.2796 3.25465 9.70264 3.58712 9.10591 3.93283L9.00687 3.99014V3.96584L9.00469 3.95696C9.00251 3.91724 9.00251 3.8777 9.00251 3.83798C9.00034 3.68163 8.99816 3.50333 8.94973 3.32051C8.91001 3.1707 8.84835 3.01435 8.66351 2.89336L8.6129 2.86035C8.51822 2.79868 8.41919 2.73266 8.30675 2.67753C8.01383 2.53224 7.6946 2.42432 7.33565 2.34724C6.8093 2.23932 6.25882 2.18653 5.65321 2.18653C5.50792 2.18653 5.36246 2.18871 5.21718 2.19542C4.87147 2.21083 4.58961 2.23278 4.3297 2.27032C3.72191 2.36064 3.25069 2.50811 2.83008 2.7459C2.65832 2.84058 2.44248 2.96173 2.3654 3.28096C2.31479 3.48356 2.28831 3.72587 2.27507 3.97237L2.12526 3.88423L1.81039 3.70593L1.7752 3.68415L1.64315 3.60706L1.60796 3.58511L1.19841 3.35168C0.953918 3.20857 0.702891 3.06546 0.427734 2.90694C0.551069 2.82985 0.641392 2.77036 0.733893 2.71758C2.29736 1.83681 3.86301 0.958046 5.42212 0.0707396C5.59171 -0.0239399 5.71722 -0.0239398 5.8868 0.0729182C7.47239 0.975809 9.06435 1.86764 10.6521 2.76383C10.7202 2.80103 10.784 2.84946 10.8742 2.9133Z"
        fill="url(#paint3_linear)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="1.59171"
        y1="2.42951"
        x2="1.59171"
        y2="2.45079"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.64" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="5.63469"
        y1="2.51711"
        x2="5.63469"
        y2="5.56429"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.64" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="1.60997"
        y1="3.78224"
        x2="1.60997"
        y2="7"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.64" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="5.65094"
        y1="0"
        x2="5.65094"
        y2="3.99014"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.64" />
      </linearGradient>
    </defs>
  </svg>
)

export default GraduationCapIcon
